export type LivestreamViewerConfig = {
  requestJoinVisible: boolean;
  shopVisible: boolean;
};

export const LIVESTREAM_VIEWER_CONFIG_MESSAGE_TYPE = "fanrank:livestreamViewerConfig";

export const LIVESTREAM_VIEWER_CONFIG_SYNC_REQUEST_MESSAGE_TYPE =
  "fanrank:livestreamViewerConfigSyncRequest";

export function getLivestreamRequestJoinVisibilityStorageKey({
  meetingId,
}: {
  meetingId: string;
}): string {
  return `fanrank:livestream:requestJoinVisible:${meetingId}`;
}

export function getLivestreamShopVisibilityStorageKey({
  meetingId,
}: {
  meetingId: string;
}): string {
  return `fanrank:livestream:shopVisible:${meetingId}`;
}

export function readPersistedRequestJoinVisible({
  meetingId,
}: {
  meetingId: string;
}): boolean {
  try {
    const stored = sessionStorage.getItem(
      getLivestreamRequestJoinVisibilityStorageKey({ meetingId }),
    );
    if (stored === null) return false;
    return stored === "true";
  } catch {
    return false;
  }
}

export function persistRequestJoinVisible({
  meetingId,
  visible,
}: {
  meetingId: string;
  visible: boolean;
}): void {
  try {
    sessionStorage.setItem(
      getLivestreamRequestJoinVisibilityStorageKey({ meetingId }),
      String(visible),
    );
  } catch {
    // ignore storage errors
  }
}

export function readPersistedShopVisible({
  meetingId,
}: {
  meetingId: string;
}): boolean {
  try {
    const stored = sessionStorage.getItem(
      getLivestreamShopVisibilityStorageKey({ meetingId }),
    );
    if (stored === null) return false;
    return stored === "true";
  } catch {
    return false;
  }
}

export function persistShopVisible({
  meetingId,
  visible,
}: {
  meetingId: string;
  visible: boolean;
}): void {
  try {
    sessionStorage.setItem(
      getLivestreamShopVisibilityStorageKey({ meetingId }),
      String(visible),
    );
  } catch {
    // ignore storage errors
  }
}

export function parseLivestreamViewerConfig({
  payload,
}: {
  payload: Record<string, boolean | number | string | Date>;
}): Partial<LivestreamViewerConfig> | null {
  const partial: Partial<LivestreamViewerConfig> = {};
  if (typeof payload.requestJoinVisible === "boolean") {
    partial.requestJoinVisible = payload.requestJoinVisible;
  }
  if (typeof payload.shopVisible === "boolean") {
    partial.shopVisible = payload.shopVisible;
  }
  return Object.keys(partial).length > 0 ? partial : null;
}

export function buildLivestreamViewerConfigPayload({
  config,
}: {
  config: LivestreamViewerConfig;
}): Record<string, boolean> {
  return {
    requestJoinVisible: config.requestJoinVisible,
    shopVisible: config.shopVisible,
  };
}

export function parseLivestreamViewerConfigSyncRequest({
  payload,
}: {
  payload: Record<string, boolean | number | string | Date>;
}): string | null {
  const participantId = payload.participantId;
  if (typeof participantId !== "string" || !participantId) return null;
  return participantId;
}

export function buildLivestreamViewerConfigSyncRequestPayload({
  participantId,
}: {
  participantId: string;
}): Record<string, string> {
  return { participantId };
}
